import React from 'react';
import styled, { css } from 'styled-components';
import Icon from 'js/components/common/Icon';
import { upTo } from 'js/services/MediaQuery';
import { inject } from 'mobx-react';

const Container = styled.div`
  align-self: start;
  justify-self: center;
  user-select: none;
`;

const reverseTruck = css`
  transform: scaleX(-1);
`;

const IconLogo = styled(Icon)`
  font-size: 2.5rem;
  ${({ direction }) => (direction === 'deliver' ? reverseTruck : null)}

  ${upTo('sm')`
    font-size: 2rem;
  `}
`;

export default inject('model')(({ model: shipment }) => (
  <Container>
    <IconLogo name="truck" direction={shipment.direction} />
  </Container>
));
